import axios from "axios";

// A response interceptor that turns 402 "limit_reached" backend errors into a
// `buddy:limit-reached` window event so <LimitReachedModal /> can render the
// correct CTA (Sign in vs Upgrade).
//
// Axios's default instance and instances created via `axios.create()` maintain
// SEPARATE interceptor chains, so this helper accepts any axios instance and
// installs the interceptor on it. `installLimitInterceptor()` (no args)
// installs on the default global instance; call it also on any custom instance
// (e.g. the one created in AuthContext.js) so every tool call is covered.
const installed = new WeakSet();

function attachTo(instance) {
  if (!instance || installed.has(instance)) return;
  installed.add(instance);
  instance.interceptors.response.use(
    (r) => r,
    (error) => {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;
      if (status === 402 && detail && typeof detail === "object" && detail.code === "limit_reached") {
        const isSignedIn = !!localStorage.getItem("buddy_access_token");
        try {
          window.dispatchEvent(new CustomEvent("buddy:limit-reached", {
            detail: {
              tool: detail.tool,
              toolLabel: detail.tool_label,
              used: detail.used,
              limit: detail.limit,
              message: detail.message,
              signedIn: isSignedIn,
            },
          }));
        } catch (_) { /* no-op */ }
      }
      return Promise.reject(error);
    }
  );
}

export function installLimitInterceptor(instance) {
  attachTo(instance || axios);
}
